import { render, staticRenderFns } from "./MarineTraffic.vue?vue&type=template&id=cc9abfa8&"
import script from "./MarineTraffic.vue?vue&type=script&lang=js&"
export * from "./MarineTraffic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports